<template>
 
     
  <v-app id="inspire">
   
        <v-navigation-drawer
         
            v-model="drawer"
           v-if="logueado"
            app
          > 
                  <center>
                  <v-toolbar color="#EE680B" dark>
                      
                      <v-col class="d-flex justify-space-around">
                      <v-toolbar-title>UNICEN</v-toolbar-title>
                      </v-col>
                     
                    </v-toolbar></center>
                  <v-list>
                    <!--<v-list-item>
                      <v-list-item-avatar>
                        <v-img src="https://cdn.vuetifyjs.com/images/john.png"></v-img>
                      </v-list-item-avatar>
                    </v-list-item>-->

                    <v-list-item-content>
                      <center>
                        <v-list-item-avatar>
                          <v-img src="/UNICEN23.jpg"></v-img>
                      </v-list-item-avatar>
                      <v-list-item-content>
                          <v-list-item-title><h5>
                        {{user.nombres}}
                      </h5></v-list-item-title>
                        </v-list-item-content>
                      <!--v-list-item-subtitle>BIENVENIDO(A) !!!</!--v-list-item-subtitle-->
                      <!--v-list-item-subtitle>****SEIKO****</v-list-item-subtitle-->
                      </center>
                     
                    </v-list-item-content>
                  </v-list>
                  <v-divider></v-divider>
                  <v-list
                    nav
                    dense
                  >
                
                        <v-list-item
                          v-for="item in dtm"
                          :key="{name:item.nombre}"
                          :to="{name:item.nombre}"
                          color="#002245"
                          
                        >
                          <v-list-item-icon>
                            <v-icon>{{ item.icon }}</v-icon>
                          </v-list-item-icon>

                          <v-list-item-content>
                            <v-list-item-title><h5>{{ item.nome}}</h5></v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
            
                        
                  </v-list>
                 
          
          
          
          </v-navigation-drawer>
         
 

    <v-app-bar color="#002245" app>
      <v-app-bar-nav-icon color="white" @click="drawer = !drawer">
         
      </v-app-bar-nav-icon>
        <v-btn
          class="mx-2"
          fab
          dark
          x-small
          color="#002245"
          @click="salir()"
          style="float:right;"
          title="CERRAR SESSION"
          >
          <v-icon dark>
              mdi-door-closed-lock
          </v-icon>
        </v-btn>
                                 <v-btn  v-if="sd!=''"
                                     class="mx-2"
                                     fab
                                     dark
                                     x-small
                                     color="#002245"
                                     @click="cambiocontraseña()"
                                     style="float:right;"
                                     title="CAMBIAR CONTRASEÑA"
                                     >
                                     <v-icon dark>
                                         mdi-lock-reset
                                     </v-icon>
                                      </v-btn>
                                     <v-list-item-subtitle  v-if="user != null" style="color:#ffffff" align="right" >SEDE:{{user.sede}}</v-list-item-subtitle>                            
      <!--<v-toolbar-title  class="white--text">UNICEN</v-toolbar-title>-->
      
    </v-app-bar>
      <v-main>
            <v-container fluid> <!--fluid fill-height-->
              <v-slide-y-transition mode="out-in">
                <router-view/>
              </v-slide-y-transition>
      </v-container>
    </v-main>    
          <v-footer
        color="#002245"
        padless
        >
                  <v-row
                    justify="center"
                    no-gutters
                  >
                    
                    <v-col
                      class="#002245 py-4 text-center white--text"
                      cols="12"
                    >
                      {{ new Date().getFullYear() }} — <strong>UNICEN</strong>
                    </v-col>
                  </v-row>
        </v-footer>

  </v-app>


  
</template>
<script>
import axios from "axios";
  export default {
   
    data: () => ({
      rl:"",
      us:"",
      sd:"",
      dtm:[],
      drawer: null,
      //selectedItem: 0,
      user:{usuario:'',id_sede:'',id_rol:'',nombres:'',sede:''}
      
    }),
    computed:{
              logueado(){
    
                this.user=JSON.parse(sessionStorage.getItem('session'));
               
                return this.user;  
                        
                
              }
                  
      },
   
    created:function(){
         
        this.user=JSON.parse(sessionStorage.getItem('session'));
        this.rl = this.user.id_rol;
        this.us = this.user.personal;
        this.sd = this.user.id_sede;
        //this.user.dispath("autologin");
         if(this.user==null){
            
            this.$router.push("/login");
            
          }
          this.listme(this.rl,this.us,this.sd);     
          
          },
    methods:{
      async listme() {
      let me = this;
      await axios
        .get("/busme/" + this.rl + "," + this.us + "," + this.sd)
        .then(function (response) {
          if (response.data.resultado == null) {
            me.dtm = [];
            
          } else {
            //console.log(response.data);
            me.dtm = response.data.resultado;
          
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    cambiocontraseña(){
            this.$router.push("/cambiopasest");
         }, 
         salir(){
          this.rl = "";
        this.us = "";
        this.sd = "";
           sessionStorage.clear();
           this.user={};
            this.$router.push("/login");
         }
    }
          

   
   
  
  }
</script>
